module.exports = __webpack_public_path__ + "img/water.fdb99689.svg";